import { Account, makeAccount } from './data.ts';
import { Storage } from './storage.ts';

export default class StorageInBrowser implements Storage {
  private readonly LIST_KEY: string;

  private readonly INDEX_KEY: string;

  static init() {
    return new StorageInBrowser();
  }

  constructor() {
    this.LIST_KEY = 'accountsList';
    this.INDEX_KEY = 'accountsCurrentIndex';

    if (!localStorage.getItem(this.LIST_KEY)) {
      localStorage.setItem(this.LIST_KEY, JSON.stringify([]));
    }

    if (!localStorage.getItem(this.INDEX_KEY)) {
      localStorage.setItem(this.INDEX_KEY, '-1');
    }
  }

  getCurrentIndex(): number {
    return Number(localStorage.getItem(this.INDEX_KEY));
  }

  setCurrentIndex(index: number) {
    localStorage.setItem(this.INDEX_KEY, String(index));
  }

  getList(): Account[] {
    const parsedJSON = JSON.parse(localStorage.getItem(this.LIST_KEY) as string);
    return parsedJSON.map(makeAccount);
  }

  setList(list: Account[]) {
    localStorage.setItem(this.LIST_KEY, JSON.stringify(list));
  }
}
